import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Button
} from "reactstrap";
import Select from "react-select";
import "./index.css";
import api from "../../api";

function ResetPassword() {
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('')
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const resetPassword = () => {
    api.fetchAPI({
      method: 'put',
      uri: `user/reset_password`,
      body: {
        current_password: currentPassword,
        password,
        confirm_password: confirmPassword,
      },
      success: response => {
        if (response.status === 'ok') {
          window.location = `/`;
        } else {
          alert(response.data.message);
        }
      },
      error: error => {
        console.error(error);
      }
    });
  };

  useEffect(() => {}, []);

  return (
    <Container>
      <div className="container">
        <Row>
          <Col sm="12" md={{ size: 8, offset: 2 }}>
            <h2 style={{ textAlign: "center" }}>Reset password</h2>
          </Col>
        </Row>
      </div>
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <label>Current password</label>
          <Input
            type="password"
            value={currentPassword}
            onChange={e => {
              setCurrentPassword(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <label>New password</label>
          <Input
            type="password"
            value={password}
            onChange={e => {
              setPassword(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <label>Repeat new password (for confirmation)</label>
          <Input
            type="password"
            value={confirmPassword}
            onChange={e => {
              setConfirmPassword(e.target.value);
            }}
          />
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          <Button color="primary" block onClick={resetPassword}>
            Confirm new password
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
